import React, { useState } from 'react'

import { getTranslate, getActiveLanguage } from 'react-localize-redux'
import { Button, Card, DatePicker, Form } from 'antd'
import { connect } from 'react-redux'
import { faEdit, faBirthdayCake } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isMoment } from 'moment'

import IconButton from '../../antd/Buttons/IconButton'
import { DATE_WITHOUT_TIME, EUROPEAN_DATE, LanguageTags } from '../../../utils/constants'
import { API_DATE, getTimezoneLessMoment } from '../../../utils/momentjs'

const TITLE = 'misc.birthdate'
const EMPTY_MESSAGE = 'student_profile.birthdate.empty_birthdate'

const mapStateToProps = state => ({ t: getTranslate(state.locale), lang: getActiveLanguage(state.locale) })

const BirthdateForm = ({ t, lang, birthdate, form, onSubmit }) => {
  const [isInEditionMode, setIsInEditionMode] = useState(false)

  const { getFieldDecorator } = form

  const handleSubmit = e => {
    e.preventDefault()

    form.validateFields((err, values) => {
      if (!err && isMoment(values.birthdate)) {
        onSubmit(values.birthdate.format(API_DATE))
      }
    })

    setIsInEditionMode(!isInEditionMode)
  }

  return (
    <div className='inner-margin'>
      <Card
        type='inner'
        title={[<FontAwesomeIcon key='title-icon' icon={faBirthdayCake} />, ' ', t(TITLE)]}
        extra={(<IconButton icon={faEdit} onClick={() => setIsInEditionMode(!isInEditionMode)} />)}
      >
        {!isInEditionMode && (birthdate ? <span> {getTimezoneLessMoment(birthdate).format(EUROPEAN_DATE)} </span> : t(EMPTY_MESSAGE))}
        {isInEditionMode && (
          <Form
            name='birthdateForm'
            onSubmit={handleSubmit}
          >
            <Form.Item>
              {getFieldDecorator('birthdate')(<DatePicker format={lang.code === LanguageTags.EN ? DATE_WITHOUT_TIME : EUROPEAN_DATE} />)}
            </Form.Item>
            <Form.Item>
              <Button type='primary' htmlType='submit'>{t('Save')}</Button>
            </Form.Item>
          </Form>
        )}
      </Card>
    </div>
  )
}

export default connect(mapStateToProps)(Form.create()(BirthdateForm))
